// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.question-item {
  border: 1px solid #ddd;
  border-radius: 5px;
  margin-bottom: 10px;
  overflow: hidden;
}

.question-header {
  padding: 15px;
  background-color: #f8f9fa;
  cursor: pointer;
  display: flex;
  align-items: center;
  transition: background-color 0.2s;
}

.question-header:hover {
  background-color: #e9ecef;
}

.question-content {
  padding: 15px;
  background-color: #fff;
  border-top: 1px solid #ddd;
}

.correct-answer {
  background-color: #d4edda !important;
  border-left: 4px solid #28a745;
}

.candidate-answer {
  background-color: #cce5ff !important;
  border-left: 4px solid #007bff;
}

.wrong-answer {
  background-color: #f8d7da !important;
  border-left: 4px solid #dc3545;
}

.badge {
  font-size: 0.85em;
  padding: 5px 10px;
}

.badge-primary {
  background-color: #007bff;
}

.badge-info {
  background-color: #17a2b8;
}

.badge-success {
  background-color: #28a745;
}

.badge-warning {
  background-color: #ffc107;
  color: #000;
}

.badge-danger {
  background-color: #dc3545;
}

.badge-secondary {
  background-color: #6c757d;
}
`, "",{"version":3,"sources":["webpack://./src/app/test-assignment-detail/test-assignment-detail.component.css"],"names":[],"mappings":"AAAA;EACE,sBAAsB;EACtB,kBAAkB;EAClB,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,yBAAyB;EACzB,eAAe;EACf,aAAa;EACb,mBAAmB;EACnB,iCAAiC;AACnC;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,0BAA0B;AAC5B;;AAEA;EACE,oCAAoC;EACpC,8BAA8B;AAChC;;AAEA;EACE,oCAAoC;EACpC,8BAA8B;AAChC;;AAEA;EACE,oCAAoC;EACpC,8BAA8B;AAChC;;AAEA;EACE,iBAAiB;EACjB,iBAAiB;AACnB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;EACzB,WAAW;AACb;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;AAC3B","sourcesContent":[".question-item {\n  border: 1px solid #ddd;\n  border-radius: 5px;\n  margin-bottom: 10px;\n  overflow: hidden;\n}\n\n.question-header {\n  padding: 15px;\n  background-color: #f8f9fa;\n  cursor: pointer;\n  display: flex;\n  align-items: center;\n  transition: background-color 0.2s;\n}\n\n.question-header:hover {\n  background-color: #e9ecef;\n}\n\n.question-content {\n  padding: 15px;\n  background-color: #fff;\n  border-top: 1px solid #ddd;\n}\n\n.correct-answer {\n  background-color: #d4edda !important;\n  border-left: 4px solid #28a745;\n}\n\n.candidate-answer {\n  background-color: #cce5ff !important;\n  border-left: 4px solid #007bff;\n}\n\n.wrong-answer {\n  background-color: #f8d7da !important;\n  border-left: 4px solid #dc3545;\n}\n\n.badge {\n  font-size: 0.85em;\n  padding: 5px 10px;\n}\n\n.badge-primary {\n  background-color: #007bff;\n}\n\n.badge-info {\n  background-color: #17a2b8;\n}\n\n.badge-success {\n  background-color: #28a745;\n}\n\n.badge-warning {\n  background-color: #ffc107;\n  color: #000;\n}\n\n.badge-danger {\n  background-color: #dc3545;\n}\n\n.badge-secondary {\n  background-color: #6c757d;\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
